import { productFromSubscription } from "./selectionFromSubscription.js";
import { subscriptionLineItems, lineItemProduct } from "./subscriptionLines.js";
import { PRODUCTS } from "./config.js";

const PRODUCT_LABELS = {
  [PRODUCTS.standard]: "Standard",
  [PRODUCTS.premium]: "Premium",
  [PRODUCTS.futures]: "Futures",
};

export function subscriptionDisplayName(sub) {
  if (!sub) return "Subscription";
  const fromProduct = productFromSubscription(sub);
  if (fromProduct && PRODUCT_LABELS[fromProduct]) {
    return PRODUCT_LABELS[fromProduct];
  }
  return sub.productName || "Subscription";
}

export function subscriptionDetailLine(sub, catalog = null) {
  if (!sub) return null;

  const lines = subscriptionLineItems(sub);
  if (lines.length > 1) {
    const parts = lines
      .map((line) => {
        const product = lineItemProduct(line, catalog, sub);
        const label =
          (product && PRODUCT_LABELS[product]) ||
          line.productName ||
          "Line";
        const qty = Number(line.quantity) || 0;
        if (qty <= 0) return null;
        return `${label}: ${qty}`;
      })
      .filter(Boolean);
    if (parts.length) return parts.join(" · ");
  }

  const parts = [];
  const qty = Number(sub.quantity);
  if (qty > 0) parts.push(`${qty} account${qty === 1 ? "" : "s"}`);
  if (sub.dedicatedNickName) {
    parts.push(`Dedicated · ${sub.dedicatedNickName}`);
  }
  return parts.length ? parts.join(" · ") : null;
}
